/**
 * The external dependencies.
 */
import styled from 'styled-components';

export default styled.span`
	position: relative;

    margin: auto;
	display: block;
	width: ${({size}) => size ? size : '8'}px;
	height: ${({size}) => size ? size : '8'}px;
	border-style: solid;
	border-color: ${({color}) => color ? color : '#439DD5'};
	border-width: ${({thickness}) => thickness ? thickness : '1px 1px 0 0'};
	transform: rotate(${({rotate}) => rotate ? rotate : '45'}deg);
	transition: .3s;

	&:hover {
		border-color: ${({hoverColor}) => hoverColor ? hoverColor : '#fff'}
	}
`



// WEBPACK FOOTER //
// ./src/components/general/navigation-chevron.js